export const errorPageStrings  = {
    title: 'Oops! 404 page not found.',
    text: `Sorry, we can't find that page.`
}